export default __webpack_public_path__ + "static/media/Abbott.65fdc14e.png";